import script from "./package-product-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./package-product-info.vue?vue&type=script&lang=ts&setup=true"

import "./package-product-info.vue?vue&type=style&index=0&id=4ac3fd6c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac3fd6c"]])

export default __exports__